
const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

const API_KEY_DISPLAY_LENGTH = 17;

interface IOAuthSettings {
  partner: string,
  apiBaseUrl: string,
  authBaseUrl: string,
  accessTokenUri: string,
  authUri: string,
}

const defaultKountaOauthSettings: IOAuthSettings = {
  partner: 'Kounta',
  apiBaseUrl: 'https://api.kounta.com',
  authBaseUrl: 'https://my.kounta.com',
  accessTokenUri: '/v1/token.json',
  authUri: '/authorize'
};

const defaultKountaSplitOauthSettings: IOAuthSettings = {
  partner: 'Kounta-Split',
  apiBaseUrl: 'https://api.kounta.com',
  authBaseUrl: 'https://my.kounta.com',
  accessTokenUri: '/v1/token.json',
  authUri: '/authorize'
};

const defaultSquareOauthSettings: IOAuthSettings = {
  partner: 'Square',
  apiBaseUrl: 'https://connect.squareup.com',
  authBaseUrl: 'https://connect.squareup.com',
  accessTokenUri: "/oauth2/token",
  authUri: "/oauth2/authorize",
}

export default {
  ...(window.config as IAppConfig),
  generateUuidv4: uuidv4,
  apiKeyDisplayLength: API_KEY_DISPLAY_LENGTH,
  oAuthSettings: [ defaultKountaOauthSettings, defaultSquareOauthSettings, defaultKountaSplitOauthSettings ],
  VERSION: VERSION,
  VERSION_SHORT: VERSION.split('|')[0]
}

export const defaultNumRequests = 5;
export const defaultRequestInterval = 500;
export const LOCAL_STORAGE_PREFIX = 'nbi_admin_'; // as connect will under Admin domain, so use same prefix
